<template>
  <MarketingHeader>
    <FunnelReport ref="funnelReport" />
    <TopicTable :changedCallback="reloadReport" />
  </MarketingHeader>
</template>

<script>
import MarketingHeader from "@/marketing/components/MarketingHeader.vue";
import FunnelReport from "@/marketing/components/FunnelReport.vue";
import TopicTable from "@/marketing/components/tables/TopicTable.vue";

// Écran « Contenus » : concevoir et préparer. La répartition par intention se recalcule après chaque modification d'un sujet.
export default {
  name: 'TopicView',
  components: {MarketingHeader, FunnelReport, TopicTable},
  methods: {
    reloadReport() {
      return this.$refs.funnelReport?.load();
    },
  },
}
</script>
